import React from "react";
import { useLocation } from "react-router-dom";
import { Box, Typography, Button } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

function decodeErrorParam(search) {
  const params = new URLSearchParams(search);
  const encoded = params.get("error");
  if (!encoded) return "Unknown error.";
  try {
    return atob(encoded);
  } catch {
    return "Invalid error message.";
  }
}

export default function ErrorPage() {
  const location = useLocation();
  const errorMsg = "Something went wrong while processing your request. Please try again later.";

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "#f8fafc",
        textAlign: "center",
        p: 3,
      }}
    >
      <ErrorOutlineIcon sx={{ fontSize: 120, color: "#e57373", mb: 2 }} />
      <Typography variant="h3" fontWeight={700} color="#d32f2f" gutterBottom>
        Oops! Something went wrong
      </Typography>
      <Typography variant="h6" color="text.secondary" sx={{ mb: 3 }}>
        {errorMsg}
      </Typography>
      <Button
        variant="contained"
        color="primary"
        size="large"
        onClick={() => window.location.href = "/scan"}
        sx={{ mt: 2 }}
      >
        Back to Scan
      </Button>
      <Box
        component="img"
        src="https://illustrations.popsy.co/gray/error.svg"
        alt="Error Illustration"
        sx={{ width: 340, maxWidth: "90vw", mt: 4 }}
      />
    </Box>
  );
}
